
export default {
  props: {
    height: { type: String, default: "" },
    factor: { type: [Number, String], default: "" },
    timeline: { type: Array, default: () => [] },
  },
}
